import { callApiMultipart } from "@src/api/callApiMultipart"
import { PARTNER } from "@src/partner"

type PUT_PARTNER_RESPONSE = PARTNER

export const putPartnerUuidLogo = (partnerUuid: string, file: File) => {
  const formData = new FormData()
  formData.append("partner[logo]", file)

  return callApiMultipart<PUT_PARTNER_RESPONSE>({
    method: "PUT",
    path: `/partner/${partnerUuid}/logo`,
    formData,
  })
}
